var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForMinorsYt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1638 29.3979L27.4469 24.9882V33.8076L35.1638 29.3979Z",
    fill: "#E97737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.98877 29.3979C0.98877 13.1619 14.1507 0 30.3867 0C46.6227 0 59.7845 13.1619 59.7845 29.3979C59.7845 45.6339 46.6227 58.7958 30.3867 58.7958C14.1507 58.7958 0.98877 45.6339 0.98877 29.3979ZM41.7784 19.6598C43.0645 20.0273 43.9832 20.946 44.3507 22.2322C45.0856 24.6207 45.0856 29.3979 45.0856 29.3979C45.0856 29.3979 45.0856 34.175 44.5344 36.5636C44.1669 37.8498 43.2482 38.7685 41.962 39.1359C39.5735 39.6871 30.3867 39.6871 30.3867 39.6871C30.3867 39.6871 21.0161 39.6871 18.8112 39.1359C17.5251 38.7685 16.6064 37.8498 16.2389 36.5636C15.6877 34.175 15.6877 29.3979 15.6877 29.3979C15.6877 29.3979 15.6877 24.6207 16.0552 22.2322C16.4227 20.946 17.3414 20.0273 18.6275 19.6598C21.0161 19.1086 30.2029 19.1086 30.2029 19.1086C30.2029 19.1086 39.5735 19.1086 41.7784 19.6598Z",
    fill: "#E97737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForMinorsYt);
export default __webpack_public_path__ + "static/media/forMinors-yt.a179f8cca4732efb6c9460545f2afa7f.svg";
export { ForwardRef as ReactComponent };